import { KeyValue } from '@angular/common';

export enum AllowedMimeTypes {
  Images = 0,
  MP4Videos,
  RARArchive,
  ZIPArchive,
  PDF,
  MSWord,
}

export const AllowedMimeTypesTranslationMap = new Map<number, string>([
  [AllowedMimeTypes.Images, 'FILES.MIMETYPE.IMAGES'],
  [AllowedMimeTypes.MP4Videos, 'FILES.MIMETYPE.MP4_VIDEOS'],
  [AllowedMimeTypes.MSWord, 'FILES.MIMETYPE.MS_WORD'],
  [AllowedMimeTypes.PDF, 'FILES.MIMETYPE.PDF'],
  [AllowedMimeTypes.RARArchive, 'FILES.MIMETYPE.RAR_ARCHIVE'],
  [AllowedMimeTypes.ZIPArchive, 'FILES.MIMETYPE.ZIP_ARCHIVE'],
]);

export const ALLOWED_MIME_TYPES: KeyValue<AllowedMimeTypes, string>[] = [
  {
    key: AllowedMimeTypes.MSWord,
    value:
      'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  { key: AllowedMimeTypes.PDF, value: 'application/pdf' },
  {
    key: AllowedMimeTypes.ZIPArchive,
    value: 'application/zip,application/x-zip-compressed',
  },
  {
    key: AllowedMimeTypes.RARArchive,
    value: 'application/vnd.rar,application/x-rar,application/x-compressed',
  },
  { key: AllowedMimeTypes.Images, value: '.jpg,.jpeg,.png,.gif,.webp' },
  {
    key: AllowedMimeTypes.MP4Videos,
    value: '.mp4,.mov,.avi,.wmv,.flv,.mkv,.webm',
  },
];

export const MAX_FILE_SIZE_IN_MEGA = 20; // 20MB
export const MIN_FILE_SIZE_IN_MEGA = 1;
export const DEFAULT_MAX_FILE_SIZE_IN_BYTES =
  MAX_FILE_SIZE_IN_MEGA * 1024 * 1024;
export const DEFAULT_MAX_TOTAL_FILES_SIZE_IN_BYTES = 20 * 1024 * 1024; // 20MB
export const MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * MAX_FILE_SIZE_IN_MEGA;
export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
export const ALLOWED_VIDEO_EXTENSIONS = [
  'mp4',
  'mov',
  'avi',
  'wmv',
  'flv',
  'mkv',
  'webm',
];
